export default __webpack_public_path__ + "static/media/3.bd21ddd1.jpg";